import BrMultistateCheckbox, { CheckboxStates } from './BrMultistateCheckbox';

BrMultistateCheckbox.State = CheckboxStates;
export default BrMultistateCheckbox;
